import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      ~~ There should be footer, but someone stole it ~~
    </footer>
  );
};

export default Footer;
